import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography, Box, Skeleton } from '@mui/material';
import { CustomButtonGroup, SankeyChart } from '../../../shared';
import { VENDOR_AFFINITY_CHANNELS } from './constants';
import { getVendorAffinity } from '../../../../redux/thunks/physicanTargetListAnalysisThunk';
import { actions } from '../../../../redux/reducers/physicianTargetListAnalysisReducer';

function VendorAffinity(props) {
    const { } = props;
    const dispatch = useDispatch();
    const { setVendorAffinityChannel } = actions;
    const { company } = useSelector(state => state.company);
    const { vendorAffinity } = useSelector(state => state.physicianTargetListAnalysis);
    const { isLoading, chartSeries, categories, selectedChannel, vendors } = vendorAffinity;

    useEffect(() => {
        if(company.id){
            dispatch(getVendorAffinity({companyId: company.id}))
        }
        
    },[company.id])

    return (
        <Box className="box-sizing-border-box">
            <Typography className="text-lg-semi-bold gray-900">
                Vendor Affinity
            </Typography>
            <Grid container spacing={'24px'} className="flex-row">
                <Grid item xs={12} >
                    <Box className="padding-24px">
                        <Box>
                            <CustomButtonGroup
                                data={categories}
                                selected={selectedChannel}
                                handleClick={(option) => dispatch(setVendorAffinityChannel({channel: option}))}
                                customStyle={{
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                }}
                                isButtonWidthEqual={true}
                            />
                        </Box>
                        {isLoading ? <Skeleton variant='rectangular' width={'100%'} height={400}/> :
                        <SankeyChart 
                            vendors={vendors }
                            chartSeries={chartSeries}
                        />
                        }
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}

export default VendorAffinity;
